export type actionResponse = {
  status_ok: boolean
  message?: string
  data?: unknown
  filename?: string
}

export interface CmsVideo {
  video_path: string
  autoplay: boolean
  muted: boolean
  loop: boolean
  controls: boolean
  poster: string
  preload: 'auto' | 'metadata' | 'none'
  playsinline?: boolean
  width?: number
  height?: number
}

export const defaultVideoValues: CmsVideo = {
  video_path: '',
  autoplay: true,
  muted: true,
  loop: true,
  controls: false,
  poster: '',
  preload: 'auto',
  playsinline: true
}

export interface CmsImage {
  src: string
  alt: string
  width?: number
  height?: number
  format?: 'jpg' | 'png' | 'gif' | 'webp' | 'avif' | 'pjpg'
  loading?: 'lazy' | 'eager'
  fit?: 'cover' | 'contain' | 'fill' | 'inside' | 'outside'
  quality?: number // 1–100
}

export const defaultImageValues: CmsImage = {
  src: '/',
  alt: 'Nie wczytano obrazu',
  format: 'webp',
  loading: 'lazy',
  fit: 'cover',
  quality: 100
}

export interface CmsLink {
  href: string
  link_text: string
  target: '_self' | '_blank' | '_parent' | '_top'
  rel?: 'noopener' | 'noreferrer' | 'noopener noreferrer' | 'nofollow'
  aria_label?: string
}

export const defaultLinkValues: CmsLink = {
  href: '',
  link_text: 'Lorem Ipsum',
  target: '_self',
  rel: 'noopener noreferrer'
}

export enum CmsItemValueType {
  text = 'text',
  imagePath = 'imagePath'
}

export interface CmsItemValue {
  name: string
  type: CmsItemValueType
  value: string
}

export type CustomCmsItem = {
  imagePath: CmsItemValue
  text: CmsItemValue
}

export const custom_element_default_values: CustomCmsItem[] = [
  {
    imagePath: {
      name: 'img',
      type: CmsItemValueType.imagePath,
      value: 'loremIpsum'
    },
    text: {
      name: 'txt',
      type: CmsItemValueType.text,
      value: 'lorem ipsum'
    }
  }
]

export type CmsText = { value: string }

export type CmsCustomComponentType = Record<string, CustomComponentValue>

export type CmsComponentData = CmsText | CmsVideo | CmsLink | CmsImage | CmsCustomComponentType | CmsCustomComponentType[]

export type CmsComponent = {
  component_type: string
  component_data: CmsComponentData | CmsComponent[]
}

export type CmsData = {
  [key: string]: CmsData | CmsComponentData | CmsComponent | CmsComponent[] | PageSettings
}

export type gitPipelineStatus
  = | 'created'
    | 'waiting_for_resource'
    | 'preparing'
    | 'pending'
    | 'running'
    | 'success'
    | 'failed'
    | 'canceled'
    | 'skipped'
    | 'manual'
    | 'scheduled'
    | null

export type PageSettings = {
  slug: string
  metaTitle: string
  metaDescription: string
  indexPage: boolean
  customHeadCode: string
  customBodyCode: string
  favico16: string
  favico32: string
  favico48: string
  favico64: string
  favico180: string
  favico192: string
  favico512: string
  faviconIco: string
  appleTouchIcon: string
  manifest: string
  ogTitle: string
  ogDescription: string
  ogImage: string
  twitterCard: string
  group: string
  public: boolean
  customData: Record<string, unknown>
}

export const default_page_settings: PageSettings = {
  slug: '',
  metaTitle: '',
  metaDescription: '',
  indexPage: true,
  customHeadCode: '',
  customBodyCode: '',
  favico16: '',
  favico32: '',
  favico48: '',
  favico64: '',
  favico180: '',
  favico192: '',
  favico512: '',
  faviconIco: '',
  appleTouchIcon: '',
  manifest: '',
  ogTitle: '',
  ogDescription: '',
  ogImage: '',
  twitterCard: '',
  group: 'default',
  public: false,
  customData: {}
}

export type CmsSettings = {
  unpublished_changes: boolean
  siteName: string
  metaTitle: string
  metaDescription: string
  customHeadCode: string
  customBodyCode: string
  customFooterCode: string
  favico16: string
  favico32: string
  favico48: string
  favico64: string
  favico180: string
  favico192: string
  favico512: string
  faviconIco: string
  appleTouchIcon: string
  manifest: string
  logo: string
  ogTitle: string
  ogDescription: string
  ogImage: string
  twitterCard: string
  canonicalUrl: string
  googleAnalyticsId: string
  googleMapsId: string
  microsoftClarity: string
  googleTagId: string
  reCAPTCHAv2SiteKey: string
  reCAPTCHAv2SecretKey: string
  cookiebotId: string
}
export const default_cms_settings: CmsSettings = {
  unpublished_changes: false,
  siteName: '',
  metaTitle: '',
  metaDescription: '',
  customHeadCode: '',
  customBodyCode: '',
  customFooterCode: '',
  favico16: '',
  favico32: '',
  favico48: '',
  favico64: '',
  favico180: '',
  favico192: '',
  favico512: '',
  faviconIco: '',
  appleTouchIcon: '',
  manifest: '',
  logo: '',
  ogTitle: '',
  ogDescription: '',
  ogImage: '',
  twitterCard: '',
  canonicalUrl: '',
  googleAnalyticsId: '',
  googleMapsId: '',
  microsoftClarity: '',
  googleTagId: '',
  reCAPTCHAv2SiteKey: '',
  reCAPTCHAv2SecretKey: '',
  cookiebotId: ''
}

export type page = {
  slug: string
  isCustomPage: boolean
  title: string
  group: string
  unpublished_changes: boolean
  created_datetime: string
  last_modified_datetime: string
  published: boolean
  public: boolean
}

export type User = {
  id: number
  email: string
  email_verified_at: string
  active: boolean
  updated_by: string
  deleted_at: string
  created_at: string
  updated_at: string
}

export type CustomComponentValue = {
  value: string | boolean | undefined
  default_value: string | boolean
  setting_label: string
  settingType: 'text' | 'file' | 'image' | 'video' | 'link' | 'boolean' | 'color' | 'select'
  selectValues?: string[]
}

export const pageGroupOptions = ['default', 'aktualność']

export interface handlerEvent {
  event?: EventListener | ((e: KeyboardEvent) => void)
  event_type: keyof WindowEventMap
  target?: HTMLElement | Window
  is_window?: boolean
}
